import { clx } from "@medusajs/ui"

import { getProductPrice } from "@lib/util/get-product-price"
import { HttpTypes } from "@medusajs/types"

export default function ProductPrice({
  product,
  variant,
}: {
  product: HttpTypes.StoreProduct
  variant?: HttpTypes.StoreProductVariant
}) {
  const { cheapestPrice, variantPrice } = getProductPrice({
    product,
    variantId: variant?.id,
  })

  const selectedPrice = variant ? variantPrice : cheapestPrice

  if (!selectedPrice) {
    return <div className="block w-32 h-9 bg-gray-100 animate-pulse" />
  }

  const hasDiscount = selectedPrice.price_type === "sale"

  return (
    <div className="flex flex-col gap-y-3 text-ui-fg-base border-t border-gray-200 pt-6">
      {/* Regular Price */}
      {hasDiscount && (
        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-500 tracking-wider">Regular price</span>
          <span
            className="text-xl text-gray-400 line-through"
            data-testid="original-product-price"
            data-value={selectedPrice.original_price_number}
          >
            {selectedPrice.original_price}
          </span>
        </div>
      )}
      
      {/* Sale/Current Price */}
      <div className="flex items-baseline gap-3">
        <span className="text-sm text-gray-500 tracking-wider">
          {hasDiscount ? "Sale price" : "Price"}
        </span>
        <span
          className={clx("text-3xl md:text-4xl font-bold", {
            "text-ui-fg-interactive": hasDiscount,
            "text-black": !hasDiscount,
          })}
          data-testid="product-price"
          data-value={selectedPrice.calculated_price_number}
        >
          {!variant && "From "}
          {selectedPrice.calculated_price}
        </span>
      </div>

      {hasDiscount && (
        <div className="inline-block bg-red-600 text-white text-xs font-bold px-3 py-1 rounded w-fit">
          SAVE {selectedPrice.percentage_diff}%
        </div>
      )}
    </div>
  )
}
